import lazyWithRetry from 'services/lazyWithRetry';
import { Resource } from 'typings/shared';
import api from './api';
import { paths, routes } from './pages/routes';
import { actions, selectors } from './store';
import { OwnerApiItem } from './types';

export const translationKey = 'Owner';

const resource: Resource<OwnerApiItem, typeof paths, typeof api, typeof actions, typeof selectors, typeof routes> = {
    name: 'owner',
    translationKey,
    api,
    selectors,
    paths,
    routes,
    actions,
    component: lazyWithRetry(() => import('./pages')),
};

export default resource;
